export default __webpack_public_path__ + "static/media/8.00f7843e.jpg";